import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const authState = JSON.parse(localStorage.getItem("auth0-token-storage"));
  const token = authState?.access_token;
  const userClaims = JSON.parse(localStorage.getItem("user-claims"));

  // Check authentication
  if (!token || !userClaims) {
    return <Navigate to="/login" />;
  }

  // If no roles are defined, allow any authenticated user
  if (allowedRoles.length === 0) {
    return children;
  }

  // Check roles
  const userRoles = Array.isArray(userClaims.roles) ? userClaims.roles : [];
  const userHasRole = userRoles.some((role) =>
    allowedRoles.includes(role.name)
  );

  if (!userHasRole) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default PrivateRoute;
